// ----------------------------------------------------------------------------
// Component: Dispenser Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

import './_dispenser-banner.scss';

var windowSize = window.innerWidth;
var dispenserProductImgAnimate = $('.dispenser-product__image-animate');

function dispenserProductImgSlideDesktop() {
    dispenserProductImgAnimate.each(function(i, el){
        var $this = $(el);
        var windowTop = $(window).scrollTop();
        var elementTop = $this.offset().top - 1000;
        var leftPosition = windowTop - elementTop;
        $this.css("transform", 'translateY(0px)');

        if( leftPosition > 0 ) {
            $this.css("transform", 'translateX(-'+leftPosition+'px)');
        } else {
            $this.css("transform", 'translateX('+leftPosition * -1+'px)');
        }
    });
}

function dispenserProductImgSlideMobile() {
    dispenserProductImgAnimate.each(function(i, el){
        var $this = $(el);
        var windowTop = $(window).scrollTop();
        var elementTop = $this.parent('.dispenser-banner__image').offset().top - 1000;
        var topPosition = windowTop - elementTop;
        $this.css("transform", 'translateX(0px)');
        $this.css("transform", 'translateY('+topPosition+'px)');
    });
}

if( windowSize >= 1024 ) {
    window.addEventListener('scroll', function() {
        dispenserProductImgSlideDesktop();
    });
} else {
    window.addEventListener('scroll', function() {
        dispenserProductImgSlideMobile();
    });
}

window.addEventListener('resize', (event) => {
    var windowSize = window.innerWidth;

    if( windowSize >= 1024 ) {
        window.addEventListener('scroll', function() {
            dispenserProductImgSlideDesktop();
        });
    } else {
        window.addEventListener('scroll', function() {
            dispenserProductImgSlideMobile();
        });
    }
});
